import { cn } from "@/ds/utils";
import type { FC } from "react";

export interface ProductImageProps {
	imageUrl: string;
	className?: string;
}

export const ProductImage: FC<ProductImageProps> = props => {
	const {
		imageUrl,
		className
	} = props;

	return (
		<div
			style={{ backgroundImage: `url(${imageUrl})` }}
			className={cn("w-8 rounded-[15%] aspect-400/558 bg-background bg-contain bg-center bg-no-repeat", className)}></div>
	);
};
